import { v, type Infer } from "convex/values";

const nodeTypeValues = [
  "link",
  "image",
  "blocknote",
  "value",
  "title",
  // Un fichier (PDF, Word, Excel, zip…), dans `values.file` (cf.
  // `lib/fileNode.ts`).
  "file",
  "table",
  "app",
  "audio",
  "video",
  // Conteneur : regroupe des nodes, qui le déclarent en `parentId` et portent
  // dès lors une position RELATIVE à lui. Seul type à le faire — c'est ce qui
  // rend le groupement explicite, là où la minimap devait jusqu'ici le
  // deviner à la proximité. Ne se crée qu'à la souris (`creatable: false`).
  "frame",
  // Conteneur à espaces : ses enfants sont rangés dans les espaces de son
  // arbre de layout (cf. `convex/config/boardConfig.ts`), pas posés librement.
  "board",
  // Node défini par l'utilisateur : la forme des values est portée par un
  // document nodeTemplates (cf. nodeDatas.templateId), pas par nodeConfig.
  "custom",
  // Une collection de fiches typées par un template : ses lignes sont des
  // nodeDatas `custom` sans node, rattachées par `databaseId` (cf.
  // models/databaseModels.ts).
  "database",
  // Une vue d'une Database posée sur le canvas (table, kanban, galerie,
  // timeline) : sa config dans `values.view`, sa Database dans `viewOf`. Le
  // node `database` montre, lui, la table complète.
  "databaseView",
] as const;

const nodeTypeValidator = v.union(
  ...nodeTypeValues.map((type) => v.literal(type)),
);

type NodeType = Infer<typeof nodeTypeValidator>;

export { nodeTypeValues, nodeTypeValidator };
export type { NodeType };
